var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "home-act-view" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isHomeFloatBanner,
                expression: "isHomeFloatBanner",
              },
            ],
            staticClass: "float-layer-view",
          },
          [
            _c("div", { staticClass: "act-view" }, [
              _c("img", {
                staticClass: "float-img",
                attrs: { src: _vm.floatImgUrl },
                on: { click: _vm.clickFloatBanner },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "close-btn",
                on: { click: _vm.closeFloat },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isHomeFloatBanner,
              expression: "!isHomeFloatBanner",
            },
          ],
          staticClass: "icon-banner",
          class: { "icon-scroll": _vm.isScrolling },
          style: { "background-image": `url(${_vm.iconImgUrl})` },
          on: { click: _vm.clickIconBanner },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }